'use client';
import { useTransition } from 'react';
import { useTranslations } from 'next-intl';
import { revalidateGetSummary } from 'services/summary/actions';
import { Conditional } from '@cat-ecom/pcc-components';
import ErrorMessage from 'components/error-message';
import { ProductCardGridLoader } from '../../../product-card/product-card-loader';

export const RecentViewErrorMessage = () => {
  const [ispending, startTransition] = useTransition();
  const t = useTranslations();
  const handleOnRetry = () => {
    startTransition(async () => {
      await revalidateGetSummary();
    });
  };
  return (
    <Conditional
      test={!ispending}
      fallback={
        <ProductCardGridLoader
          isHeaderLoader={false}
          title={t('RECENTLY_VIEWED')}
        />
      }
    >
      <ErrorMessage
        retryButtonLabel="RETRY"
        errorMessage="API_FAILURE_RETRY"
        onRetry={handleOnRetry}
      />
    </Conditional>
  );
};
